import { Component, Input, OnInit } from '@angular/core';

@Component({
  standalone: false,
  selector: 'ui-order-line-status-badge',
  templateUrl: './ui-order-line-status-badge.component.html',
  styleUrls: ['./ui-order-line-status-badge.component.scss']
})
export class UiOrderLineStatusBadgeComponent implements OnInit {
  @Input() status: string;

  public ORDER_LINE_STATUSES = {
    NEW: 'NEW',
    EDITED: 'EDITED',
    DELETED: 'DELETED'
  };

  ngOnInit(): void {
  }
}
